

<body>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
    <div class="row">
    <div class="col-md-6 mx-auto">
      <div class="card bbb_deals">
        <button (click)="regresarPagina()" style="width: 100px; height: 30px; padding: 0px; border: 0px;" class="btn btn-outline-info"><i class="fa fa-hand-o-left" style="margin-right: 8px;"></i>Regresar</button>
        <div class="card-body">
          <div class="card-title">
            <h2>Reseteo de contraseña</h2>
          </div>
          <form [formGroup]="formularioResetPassword" class="form-material" (ngSubmit)="resetearPassword()">

            <div class="form-group">
              <div class="input-group">
                <div class="input-group-addon"></div>
                <input formControlName="correo" type="email" email required minlength="5" maxlength="30" class="form-control"
                placeholder="Nombre de usuario (Correo electrónico)" />
              </div>
              <div class="alert-danger" *ngIf="correo.invalid && (correo.dirty || correo.touched)" >
                <div class="container-error-message" *ngIf="correo.errors.required" >
                  El correo es requerido
                </div>
                <div class="container-error-message" *ngIf="correo.errors.minlength">
                  El correo debe tener mínimo 5 caracteres
                </div>
                <div class="container-error-message" *ngIf="(correo.dirty || correo.touched) && correo.invalid && correo.errors.pattern">
                  Debe ser un correo válido
                </div>
                <div class="container-error-message" *ngIf="correo.errors.maxlength">
                  El correo debe tener máximo 30 caracteres
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button type="submit" class="btn btn-block btn-md btn-success btn-rounded" [disabled]="!formularioResetPassword.valid">
                  Resetear Contraseña
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
</body>
